import { render, staticRenderFns } from "./ExtraPayment.vue?vue&type=template&id=bc1f7520"
import script from "./ExtraPayment.vue?vue&type=script&lang=js"
export * from "./ExtraPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports